import { useEffect, useState } from "react";
import { fetchMyNavigation } from "../api/navigationApi";

export function useRoleNavigation(roleSlug, enabled = true) {
  const [navItems, setNavItems] = useState([]);
  const [titleByPath, setTitleByPath] = useState({});
  const [loading, setLoading] = useState(Boolean(enabled));
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!enabled || !roleSlug) {
      setLoading(false);
      return undefined;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchMyNavigation(roleSlug);
        if (cancelled) return;
        setNavItems(Array.isArray(data?.navItems) ? data.navItems : []);
        setTitleByPath(
          data?.titleByPath && typeof data.titleByPath === "object"
            ? data.titleByPath
            : {}
        );
      } catch (err) {
        if (cancelled) return;
        if (err?.response?.status === 401 || err?.message === "session_timeout") {
          return;
        }
        setNavItems([]);
        setTitleByPath({});
        setError(err?.message || "Failed to load navigation");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [roleSlug, enabled]);

  return { navItems, titleByPath, loading, error };
}
